import { useDebouncedState, useErrorToast } from '@react/lib/hooks';
import ReportsTable from './reports';
import { flatMap } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useReportsQuery } from './hooks';
var Reports = function () {
    // TODO: Make reports searchable
    var _a = useState(''), searchInputValue = _a[0], setSearchInputValue = _a[1];
    var _b = useState({}), filters = _b[0], setFilters = _b[1];
    var searchTerm = useDebouncedState(searchInputValue, 500);
    var _c = useReportsQuery({ searchTerm: searchTerm, filters: filters }), data = _c.data, isLoading = _c.isLoading, fetchNextPage = _c.fetchNextPage, hasNextPage = _c.hasNextPage, isFetchingNextPage = _c.isFetchingNextPage, isError = _c.isError;
    var onScrollToEnd = function () {
        var shouldFetchNextPage = hasNextPage && !isLoading && !isFetchingNextPage;
        if (shouldFetchNextPage) {
            fetchNextPage();
        }
    };
    var loading = isLoading || isFetchingNextPage;
    var reports = useMemo(function () { return data && data.pages && flatMap(data.pages, function (page) { return page.data; }); }, [data]);
    // TODO: localisation
    useErrorToast(isError, {
        title: 'Error',
        message: 'Failed to load reports'
    });
    return (React.createElement(React.Fragment, null, reports && reports.length > 0 && (React.createElement(ReportsTable, { data: reports, loading: loading, onScrollToEnd: onScrollToEnd }))));
};
var ɵ0 = Reports;
export default Reports;
export { ɵ0 };
